import Dropdown from '@shared/components/dropdowns';
import { html, nothing } from '@shared/utils/rendering/html';
import { useEffect, useState } from 'preact/hooks';
import { useCachedFetch } from '../../../utils/hooks/use-cached-fetch';

const LegalEntitiesFilter = ({ field, setValidEntities, params = {} }) => {
    const [options, setOptions] = useState([]);
    const { data: legalEntities, isLoading, isSuccess } = useCachedFetch('/legal-entities', params);

    useEffect(() => {
        if (!isLoading && isSuccess && legalEntities?.length) {
            setOptions(legalEntities);
            setValidEntities(legalEntities);
        }
        if (!isLoading && isSuccess && !legalEntities?.length) {
            field?.setValue(null, field);
        }
        if (!isLoading && isSuccess && legalEntities?.length == 1) {
            field?.setValue(legalEntities[0], field);
        }
    }, [legalEntities]);

    return html`<div id="legal-entities-org-filter">
        <${Dropdown}
            label=${{ text: 'Legal Entity / Business Unit' }}
            options=${options}
            field=${field}
            settings=${{
                multiple: false,
                type: 'input',
            }}
            disabled=${options?.length <= 1}
        />
        ${
            !options?.length
                ? html`<span class="help-text">You are not assigned to any legal entities.</span>`
                : nothing
        }
    </div>`;
};

export default LegalEntitiesFilter;
